export default __webpack_public_path__ + "static/media/stockCatalogpage.c3916f60.png";